import { recipientInstance } from '../utils/axiosConfig';

const RecipientService = {
    // Créer un nouveau destinataire
    createRecipient: async (recipientData) => {
        try {
            const response = await recipientInstance.post('/create', recipientData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in createRecipient:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un destinataire
    updateRecipient: async (recipientData) => {
        try {
            const response = await recipientInstance.put('/update', recipientData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateRecipient:', error.message || error);
            throw error;
        }
    },

    // Supprimer un destinataire
    deleteRecipient: async (id) => {
        try {
            const response = await recipientInstance.delete(`/delete/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in deleteRecipient:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les destinataires
    getAllRecipients: async () => {
        try {
            const response = await recipientInstance.get('/findAll');
            return response.data;
        } catch (error) {
            console.error('Error in getAllRecipients:', error.message || error);
            throw error;
        }
    },

    // Récupérer un destinataire par son ID
    getRecipientById: async (id) => {
        try {
            const response = await recipientInstance.get(`/find/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getRecipientById:', error.message || error);
            throw error;
        }
    },

    // Rechercher des destinataires par divers paramètres
    findRecipientsByVariousParameters: async (firstName, lastName, country, city, province, neighborhood, enabled) => {
        try {
            const response = await recipientInstance.get(`/findUser/${firstName}/${lastName}/${country}/${city}/${province}/${neighborhood}/${enabled}`);
            return response.data;
        } catch (error) {
            console.error('Error in findRecipientsByVariousParameters:', error.message || error);
            throw error;
        }
    }
};

export default RecipientService;